import React, { useEffect, useState } from "react";
import api from "../../../../configs/api";
import Ticker from "../../../ui/Ticker";
import TickerLine from "./TickerLine";

export default function Comments() {
  const [usersComments, setUsersComments] = useState([]);

  const getUsersComments = async () => {
    try {
      const res = await api.get("/users-comments");
      setUsersComments(res?.data?.usersComments || []);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    getUsersComments();
  }, []);

  // Split the usersComments array into three parts
  const firstPart = usersComments.slice(0, Math.ceil(usersComments.length / 3));
  const secondPart = usersComments.slice(
    Math.ceil(usersComments.length / 3),
    2 * Math.ceil(usersComments.length / 3),
  );
  const thirdPart = usersComments.slice(
    2 * Math.ceil(usersComments.length / 3),
  );

  return (
    <div className='flex flex-col gap-14 my-14'>
      <Ticker pauseOnHover autoFill>
        {firstPart.map((item, index) => (
          <React.Fragment key={item?.userComment + index}>
            <TickerLine
              image={item?.userImage}
              comment={item?.userComment}
              name={item?.userName}
              showSeparator={index % 2 === 0}
            />
          </React.Fragment>
        ))}
      </Ticker>

      <Ticker pauseOnHover autoFill direction='right'>
        {secondPart.map((item, index) => (
          <React.Fragment key={item?.userComment + index}>
            <TickerLine
              image={item?.userImage}
              comment={item?.userComment}
              name={item?.userName}
              showSeparator={index % 2 === 0}
            />
          </React.Fragment>
        ))}
      </Ticker>

      <Ticker pauseOnHover autoFill>
        {thirdPart.map((item, index) => (
          <React.Fragment key={item?.userComment + index}>
            <TickerLine
              image={item?.userImage}
              comment={item?.userComment}
              name={item?.userName}
              showSeparator={index % 2 === 0}
            />
          </React.Fragment>
        ))}
      </Ticker>
    </div>
  );
}
